import React from "react";
import classnames from "classnames";

import styles from "./DetailsInfoTitle.module.scss";

interface Props {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  inactiveLine?: React.ReactNode;
  className?: string;
}

const DetailsInfoTitle = ({
  title,
  subTitle,
  inactiveLine,
  className,
}: Props) => {
  return (
    <div className={classnames(styles.detailsInfoTitle, className)}>
      <div className={styles.infoRow}>{title}</div>
      {inactiveLine}
      <div className={styles.infoRow}>
        <span>{subTitle}</span>
      </div>
    </div>
  );
};

export default DetailsInfoTitle;
